import confirm from '../../../utils/confirm.jsx';
import addError from '../../../utils/error.jsx';

export function request(id, accountId, payout) {

    return confirm('Are you sure that you want to settle this bet?', {
        type: 'BETS_SETTLE_MANUALLY_REQUEST',
        accountId,
        payout,
        id
    });
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'BETS_SETTLE_MANUALLY_ERROR',
        errors,
        id
    };
}

export function finish(id, data) {
    return {
        type: 'BETS_SETTLE_MANUALLY_FINISH',
        data,
        id
    };
}
